<template>
  <QDialog
    :value="display"
    persistent
    maximized
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <QCard class="bg-white text-grey-8 column">
      <QCardSection class="q-px-md col column q-pb-none no-wrap">
        <div class="flex full-width justify-end">
          <SAIIconBtn @click="$emit('close:acceptance-dialog')" />
        </div>
        <h4 class="q-mb-md text-application-primary">Quote Acceptance</h4>
        <span>I acknowledge that I have:</span>
        <div class="q-py-sm">
          <QuoteAcceptanceDocumentCheckbox
            :opened="openedPrivacyDocument"
            :accepted="acceptedQuotePrivacyDocument"
            tool-tip="To tick this, you must view the Privacy Disclosure and Consent"
            checkbox-label="opened, read and agree to the"
            link-label="Privacy Disclosure and Consent"
            suffix=";"
            @open="$emit('open:privacy-statement')"
            @accept="$emit('update:privacy-document-acceptance', $event)"
          />
          <QuoteAcceptanceDocumentCheckbox
            :opened="openedTermsDocument"
            :accepted="acceptedQuoteTermsDocument"
            tool-tip="To tick this, you must view the Lease Terms and Conditions"
            checkbox-label="opened, read and agree to the"
            link-label="Lease Terms and Conditions"
            suffix=";"
            @open="$emit('open:terms-and-conditions')"
            @accept="$emit('update:terms-document-acceptance', $event)"
          />
          <QuoteAcceptanceDocumentCheckbox
            :opened="openedLeaseDocument"
            :accepted="acceptedLeaseDocument"
            tool-tip="To tick this, you must view the Novated Lease Quote"
            checkbox-label="opened and read the"
            link-label="Novated Lease Quote"
            suffix="; and"
            :loading="loadingQuotePdf"
            @open="$emit('open:lease-document')"
            @accept="$emit('update:lease-document-acceptance', $event)"
          />
        </div>
        <QuoteAcceptanceCopyConfirmation
          :entity="entity"
          :fbt-tax-exemption="fbtTaxExemption"
        />
        <QSpace />
        <div class="row justify-center q-py-md q-gutter-x-sm">
          <SAIBtn
            :no-caps="true"
            outline
            color="grey-6"
            :disable="accepting"
            padding="12px xl"
            label="Close"
            @click="$emit('close:acceptance-dialog')"
          />
          <SAIBtn
            :no-caps="true"
            class="all-pointer-events"
            :disable="accepting || !enableFinalAcceptance"
            :loading="accepting"
            padding="12px xl"
            label="I Accept"
            @click="$emit('accept:accept-dialog')"
          />
        </div>
      </QCardSection>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard, QCardSection, QSpace } from 'quasar';
import { SAIIconBtn, SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'QuoteAcceptanceDialog',
  props: {
    entity: String,
    loadingQuotePdf: Boolean,
    fbtTaxExemption: Boolean,
    display: Boolean,
    accepting: Boolean,
    acceptedQuotePrivacyDocument: Boolean,
    acceptedQuoteTermsDocument: Boolean,
    openedLeaseDocument: Boolean,
    acceptedLeaseDocument: Boolean,
    enableFinalAcceptance: Boolean,
    openedPrivacyDocument: Boolean,
    openedTermsDocument: Boolean
  },
  components: {
    QDialog,
    SAIIconBtn,
    SAIBtn,
    QCard,
    QCardSection,
    QSpace,
    QuoteAcceptanceCopyConfirmation: () =>
      import('../../molecule/quote-acceptance-copy-confirmation'),
    QuoteAcceptanceDocumentCheckbox: () =>
      import('../../molecule/quote-acceptance-document-checkbox')
  }
};
</script>
